import { heroStats } from '@/mocks/home';
import Reveal from '@/components/feature/Reveal';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[560px] overflow-hidden md:min-h-[680px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20collage%20of%20torn%20newspaper%20clippings%20and%20dark%20crimson%20ink%20splashes%20on%20a%20deep%20charcoal%20surface%2C%20dramatic%20side%20lighting%2C%20high%20contrast%2C%20film%20grain%20texture%2C%20cinematic%20moody%20atmosphere%2C%20no%20text%2C%20artistic%20layered%20paper%20composition%2C%20muted%20warm%20tones%20with%20vivid%20red%20accents&width=1600&height=900&seq=hlfc-hero-01&orientation=landscape"
          alt="黑料反差爆料封面视觉：深扒内幕真相的档案拼贴"
          title="黑料反差 · 爆料实锤合集封面"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65" />
      </div>

      <div className="relative flex w-full flex-col justify-center px-4 py-20 md:px-6 md:py-28">
        <div className="grid w-full gap-12 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-8">
            <Reveal>
              <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3 py-1 font-label text-[11px] tracking-[0.2em] text-background-100 backdrop-blur">
                <i className="ri-archive-drawer-line" />
                反差档案库 · 2019 — 2026
              </span>

              <h2 className="mt-6 font-heading text-3xl font-black leading-tight text-white md:text-5xl">
                深扒内幕真相，把每一处反差
                <br className="hidden md:block" />
                都还原成可回看的证据链
              </h2>

              <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
                黑料反差实锤集中呈现：从线索收集、时间梳理到前后对照，本期共归档 2,816 条条目，
                按话题与时间两个维度建立索引，方便你按需回看，而不是被动刷屏。
              </p>

              <div className="mt-6 flex flex-wrap gap-2">
                {['黑料反差爆料', '黑料反差实锤', '黑料反差深扒'].map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full border border-white/20 bg-white/10 px-3 py-1.5 text-xs text-background-100 backdrop-blur"
                  >
                    #{tag}
                  </span>
                ))}
              </div>

              <div className="mt-9 flex flex-col gap-3 sm:flex-row">
                <a
                  href="#timeline"
                  className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-flashlight-line" />
                  查看最新实锤
                </a>
                <a
                  href="#collections"
                  className="inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/30 px-6 text-sm text-white backdrop-blur transition-colors hover:bg-white/10"
                >
                  <i className="ri-stack-line" />
                  进入合集索引
                </a>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-4 lg:pt-4">
            <Reveal delay={160}>
              <div className="rounded-lg border border-white/15 bg-white/8 p-5 backdrop-blur-md">
                <div className="flex items-center justify-between">
                  <span className="font-label text-[11px] tracking-[0.2em] text-background-200">更新条</span>
                  <span className="rounded-full bg-accent-500 px-2 py-0.5 font-label text-[10px] text-foreground-950">
                    今日 3 更
                  </span>
                </div>
                <div className="mt-5 flex flex-col divide-y divide-white/10">
                  {[
                    { time: '14:20', text: '片场花絮前后对照合集 · 第 12 次修订' },
                    { time: '11:05', text: '采访原声逐句稿 · 新增 9 处时间戳' },
                    { time: '09:40', text: '前后对照图鉴 · 收录第 200 组影像' },
                  ].map((row) => (
                    <div key={row.time} className="flex items-start gap-3 py-3 first:pt-0 last:pb-0">
                      <span className="font-label text-[11px] text-primary-300">{row.time}</span>
                      <span className="text-xs leading-relaxed text-background-100">{row.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={240}>
          <div className="mt-16 grid w-full grid-cols-2 gap-px overflow-hidden rounded-lg border border-white/15 bg-white/10 backdrop-blur md:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label} className="bg-black/25 px-5 py-6">
                <p className="font-heading text-2xl font-bold text-white md:text-3xl">{stat.value}</p>
                <p className="mt-1.5 text-xs text-background-300">{stat.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}